<template>
  <div class="notification is-warning is-light">
    <button class="delete" @click="onClosed"></button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WarningNotification',
  props: {
    label: String,
    onClosed: Function
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WarningNotification.vue